interface CountdownOverlayProps {
  value: number | null;
}

export function CountdownOverlay({ value }: CountdownOverlayProps) {
  if (value === null) return null;

  return (
    <div className="countdown-overlay" aria-live="polite" aria-atomic="true">
      <span className="countdown-number" key={value}>
        {value === 0 ? 'Go !' : value}
      </span>
    </div>
  );
}
